import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Account, TopLevelWithoutHeaderComponent } from '../../shared/models';
import { AuthService, AccountsService, Store } from '../../shared/services';

@Component({
  styles: [require('./delete-account.component.scss')],
  template: require('./delete-account.component.pug')
})
export class DeleteAccountComponent extends TopLevelWithoutHeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  account: Account;
  imageUrl = '/img/accounts_icon3.jpg';

  private _accountName: string;

  constructor(
      private _authService: AuthService,
      private _router: Router,
      public _route: ActivatedRoute,
      private _accService: AccountsService,
      public store: Store
      ) {
          super(store);
      }

  ngOnInit() {
        this._route.params.forEach((params: Params) => {
            this._accountName = params['account'];
            this.account = this._accService.getAccountByName(this._accountName);
        });
  }

  ngAfterViewInit() {
    if (!this.account) {
      this._router.navigate(['/accounts']);
    }
  }

  ngOnDestroy() {
     this.componentDestroy();
  }

  cancelClicked() {
      this._navigateToAccounts();
  }

  delete(e: MouseEvent) {
      e.preventDefault();
      this._authService.removeAccount(this._accountName);
      this._navigateToAccounts();
  }

  singout(e: MouseEvent) {
      e.preventDefault();
      this._authService.signout(this.account, true);
      this._navigateToAccounts();
  }

  private _navigateToAccounts() {
      this._router.navigate(['accounts']);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/delete-account/delete-account.component.ts